import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { scrollToElement } from "../lib/utils";
import chroma from "chroma-js";

function Success({
  className,
  message,
  heavyStyle,
  scrollTo = false,
}: {
  className?: string;
  heavyStyle?: boolean;
  message?: string;
  scrollTo?: boolean;
}): JSX.Element | null {
  const errorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (message && scrollTo && errorRef.current) {
      scrollToElement(errorRef.current);
    }
  }, [message, scrollTo]);

  const successBackground = chroma("green")
    .set("hsl.s", 0.43)
    .set("hsl.l", 0.46)
    .hex();

  return !message ? null : (
    <motion.div
      className={`rounded-md ${heavyStyle ? "p-2" : "mt-2 "} ${
        className ? className : ""
      }`}
      style={{ backgroundColor: heavyStyle ? successBackground : "" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key={message}
      ref={errorRef}
    >
      <div className="flex">
        <div className="mx-1">
          <div
            className={`text-base ${heavyStyle ? "text-white" : `text-[${successBackground}]`}`}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Success;
